import { cn } from "@/utils/utils/helpers";
import { ReactNode } from "react";
type CenteredAreaProps = {
  className?: string;
  children: ReactNode;
};
export default function CenteredArea({
  className,
  children
}: CenteredAreaProps) {
  return <div className={cn("flex h-full min-h-40 flex-grow items-center justify-center rounded-xl", className)} data-sentry-component="CenteredArea" data-sentry-source-file="centered-area.tsx">
      {children}
    </div>;
}